import { useQueryClient } from '@tanstack/react-query'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory, useParams } from 'react-router-dom'

import { useAppDispatch } from '../../App/Hooks/reduxHooks'
import {
  AbsenceFormBase,
  IAbsenceProps,
} from '../layout/AbsenceFormBase/AbsenceFormBase'
import { handelFormError } from '../layout/AbsenceFormBase/handelFormError'
import { handelFormSuccess } from '../layout/AbsenceFormBase/handelFormSuccess'

import { IAbsencePayload } from './util/createAbsencePayload'
import { usePostAbsenceMutation } from './util/useAbsenceQuery'

export const AddAbsencesPage = () => {
  const params = useParams<{ personUuid: string }>()
  const queryClient = useQueryClient()
  const { mutate, error, isSuccess, status } =
    usePostAbsenceMutation(queryClient)

  const dispatch = useAppDispatch()
  const { t } = useTranslation()
  const history = useHistory()

  const handleDataFromChild = (payload: IAbsencePayload) => {
    mutate(payload)
  }

  const addAbsenceProps: IAbsenceProps = {
    type: 'absence',
    overviewPath: '/hr/absences',
    pageTitle: t('Add absence'),
    isSelectPerson: false,
    requestStatus: status,
    newPayload: handleDataFromChild,
  }

  useMemo(
    () => handelFormError('Could not create absence.', error, t, dispatch),
    [error, t, dispatch],
  )

  useMemo(() => {
    if (isSuccess) {
      handelFormSuccess(t('Created absence.'), dispatch)
      history.push(`${addAbsenceProps.overviewPath}/${params.personUuid}`)
    }
  }, [isSuccess, history, t, dispatch])

  return <AbsenceFormBase {...addAbsenceProps} />
}
